import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";
import { head, isEmpty, empty, singleton, append } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.7.0/Fetch.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51 } from "../../../fable_modules/Thoth.Json.10.4.1/./Decode.fs.js";
import { list_type, string_type } from "../../../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { CaseStrategy } from "../../../fable_modules/Thoth.Json.10.4.1/Types.fs.js";
import { errorString, Encoders } from "../../../../Bfs.Web.Portale/./Http.fs.js";
import { fromString } from "../../../../Bfs.Web.Portale/../Bfs.Web.Kundenportal/fable_modules/Thoth.Json.10.4.1/Decode.fs.js";
import { uncurry2 } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { printf, toText } from "../../../fable_modules/fable-library-js.4.19.0/String.js";
import { Faq_Faq_$reflection } from "../../../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { FaqDisplayMode, Model, Msg, Model_get_Init } from "./Types.fs.js";
import { Cmd_none } from "../../../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { request, Loaded } from "../../../../Bfs.Web.Portale/Http.fs.js";
import { Remote$1 } from "../../../../Bfs.Web.Portale/Types.fs.js";

export function Http_getKategorien() {
    const response = fetch("/api/faq/kategorien", keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(string_type), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_getFaqs(kategorie) {
    let arg;
    const response = fetch((arg = encodeURIComponent(kategorie), toText(printf("/api/faq/kategorien/%s"))(arg)), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(Faq_Faq_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function Http_searchFaqs(query) {
    let arg;
    const response = fetch((arg = encodeURIComponent(query), toText(printf("/api/faq/search?q=%s"))(arg)), keyValueList(append(singleton(new Types_RequestProperties(4, ["include"])), empty()), 1));
    const decoder = Auto_generateBoxedDecoderCached_Z6670B51(list_type(Faq_Faq_$reflection()), new CaseStrategy(1, []), Encoders());
    return response.then((response_1_1) => {
        if (!(response_1_1.ok)) {
            throw new Error(errorString(response_1_1));
        }
        else {
            const pr = response_1_1.text();
            return pr.then((res) => {
                const matchValue = fromString(uncurry2(decoder), res);
                if (matchValue.tag === 1) {
                    throw new Error(matchValue.fields[0]);
                }
                else {
                    return matchValue.fields[0];
                }
            });
        }
    });
}

export function State_init(page, user, lastModel) {
    return [Model_get_Init(), singleton((dispatch) => {
        dispatch(new Msg(0, []));
    })];
}

export function State_update(msg, model) {
    switch (msg.tag) {
        case 1: {
            const x = msg.fields[0];
            const cmd_1 = (x.tag === 0) ? (!isEmpty(x.fields[0]) ? singleton((dispatch) => {
                dispatch(new Msg(2, [head(x.fields[0])]));
            }) : Cmd_none()) : Cmd_none();
            return [new Model(Loaded(x), model.Faqs, model.SelectedKategorie), cmd_1];
        }
        case 2: {
            const kategorie = msg.fields[0];
            return [new Model(model.Kategorien, new Remote$1(1, []), new FaqDisplayMode(1, [kategorie])), request(Http_getFaqs, kategorie, (Item_1) => (new Msg(3, [Item_1])))];
        }
        case 3:
            return [new Model(model.Kategorien, Loaded(msg.fields[0]), model.SelectedKategorie), Cmd_none()];
        case 4: {
            const query = msg.fields[0];
            return [new Model(model.Kategorien, new Remote$1(1, []), new FaqDisplayMode(2, [query])), request(Http_searchFaqs, query, (Item_2) => (new Msg(3, [Item_2])))];
        }
        default:
            return [new Model(new Remote$1(1, []), model.Faqs, model.SelectedKategorie), request(Http_getKategorien, undefined, (Item) => (new Msg(1, [Item])))];
    }
}

//# sourceMappingURL=State.fs.js.map
